/** Follow newly appended finals only while the viewer is watching the tail. */
export const liveFollowOutput = (
  viewport: HTMLElement | null,
  atBottom: boolean,
  viewingSection: boolean
): 'auto' | false => {
  if (!viewport || !atBottom || viewingSection) return false;
  const focused = document.activeElement;
  if (
    focused instanceof HTMLElement &&
    viewport.contains(focused) &&
    focused.closest('input, textarea, [contenteditable="true"]')
  )
    return false;
  const selection = window.getSelection();
  if (
    selection &&
    !selection.isCollapsed &&
    viewport.contains(selection.anchorNode)
  )
    return false;
  return 'auto';
};
